/* ============================================================
   Tolteck Dashboard — couche de données 100 % serveur.
   Remplaçait l'ancien wrapper IndexedDB : mêmes exports
   (STORES + db avec init/getAll/get/add/delete/clear) pour que
   DataContext, Couts.js et Regroupements.js ne changent pas.
   Chaque appel part en fetch vers l'API REST /api (Express + SQLite).
   ============================================================ */

export const STORES = {
  CLIENTS: 'clients',
  DEVIS: 'devis',
  FACTURES: 'factures',
  COUTS: 'couts',
  COUTSTRUCT: 'coutstruct',
  REGROUPEMENTS: 'regroupements',
  PARAMETRES: 'parametres',
};

/* Hook appelé sur 401 (session expirée). Enregistré par AuthContext. */
let unauthorizedHandler = null;
export function setUnauthorizedHandler(fn) {
  unauthorizedHandler = fn;
}

async function request(path, options = {}) {
  let res;
  try {
    res = await fetch('/api' + path, {
      credentials: 'same-origin',
      ...options,
      headers: {
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {}),
      },
    });
  } catch (error) {
    throw new Error('Serveur injoignable — lancez « npm run dev » puis rechargez la page.');
  }

  if (res.status === 401) {
    if (unauthorizedHandler) unauthorizedHandler();
    throw new Error('Session expirée. Veuillez vous reconnecter.');
  }

  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) throw new Error((data && data.error) || `Erreur ${res.status}`);
  return data;
}

class Api {
  /* Vérifie que le serveur répond (équivalent de l'ancienne ouverture de base). */
  async init() {
    await request('/health');
    return true;
  }

  async getAll(store) {
    const data = await request(`/${store}`);
    return data || [];
  }

  /* Sur introuvable (404), renvoie null — comme l'ancien IndexedDB.get(). */
  async get(store, key) {
    try {
      return await request(`/${store}/${encodeURIComponent(key)}`);
    } catch (error) {
      return null;
    }
  }

  async add(store, data) {
    const result = await request(`/${store}`, { method: 'POST', body: JSON.stringify(data) });
    return result.id;
  }

  async delete(store, id) {
    await request(`/${store}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }

  async clear(store) {
    await request(`/${store}`, { method: 'DELETE' });
  }
}

export const db = new Api();
